import { render, staticRenderFns } from "./MimdgModals.vue?vue&type=template&id=5eb93284"
import script from "./MimdgModals.vue?vue&type=script&lang=js"
export * from "./MimdgModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports